import { Link } from "react-router-dom";
import { WarningCircle, ArrowRight } from "@phosphor-icons/react";

/**
 * Persistent nudge banner for subcontractors with an incomplete profile.
 * Hides automatically once company_name and bank_name are filled.
 */
export default function ProfileIncompleteBanner({ user, profile }) {
  if (!user || user.role !== "subcontractor" || !profile) return null;

  const needsCompany = !profile.company_name;
  const needsBank = !profile.bank_name || !profile.account_number || !profile.sort_code;
  if (!needsCompany && !needsBank) return null;

  const missing = [];
  if (needsCompany) missing.push("business details");
  if (needsBank) missing.push("bank name, sort code & account number");

  return (
    <div
      className="mb-6 border border-amber-300 bg-amber-50 px-4 py-3 flex items-start gap-3 sm:items-center sm:justify-between flex-col sm:flex-row"
      data-testid="profile-incomplete-banner"
    >
      <div className="flex items-start gap-3">
        <WarningCircle size={20} weight="fill" className="text-amber-600 shrink-0 mt-0.5 sm:mt-0" />
        <div className="text-sm">
          <div className="font-semibold text-amber-900">
            Finish setting up your profile
          </div>
          <div className="text-amber-800 text-xs mt-0.5">
            Add your {missing.join(" and ")} so every invoice shows the right info.
          </div>
        </div>
      </div>
      <Link
        to="/settings"
        className="shrink-0 inline-flex items-center gap-1.5 bg-amber-600 text-white text-xs font-semibold px-3 py-1.5 rounded-sm hover:bg-amber-700 transition-colors"
        data-testid="profile-banner-cta"
      >
        Go to Settings
        <ArrowRight size={14} weight="bold" />
      </Link>
    </div>
  );
}
